export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w@2x.f757bda2.webp";